// extracted by mini-css-extract-plugin
export default {"icon-class":"icon-class__fQwiQ","tag":"tag__4Hnhf","active":"active__21A1M","blocked":"blocked__fLlq1","days-text":"days-text__CTp5f","card":"card__dpTJ1"};